

























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import cPopup from '@/components/default/Popup.vue';
import kpiValuesRepository from '@/services/varia/kpiValuesRepository';
import kpiObjects from '../kpiObjects.json';

import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxEmptyItem,
  DxLabel,
} from 'devextreme-vue/form';


@Component({
    components: {
        cCard,
        cPopup,
        DxForm,
        DxSimpleItem,
        DxGroupItem,
        DxEmptyItem,
        DxLabel,
    },
})
export default class DashboardGraph extends Vue {
    @Prop({required: true})
    public value!: IDashboardPointOfInterest;

    private data: IKpiValue = {
        moment: '',
        category: '',
        type: '',
        value: 99999999,
    };
    private loading: boolean = false;

    private item: IDashboardPointOfInterest = {
        itemType: 'pointOfInterest',
        name: '',
        width: 12,
        type: '',
        category: '',
        successToken: '=',
        successValue: null,
        warningToken: '=',
        warningValue: null,
        dangerToken: '=',
        dangerValue: null,
    };

    private showSettings: boolean = false;

    private async mounted() {
        Object.assign(this.item, this.value);
        this.loadData();
    }

    private async loadData() {
        this.loading = true;
        if (this.dataValid) {
            this.data = (await kpiValuesRepository.GetSingle({
                category: this.item.category,
                type: this.item.type,
            })).data;
        }
        this.loading = false;
    }

    private changeSettings() {
        this.showSettings = true;
    }

    private saveSettings() {
        this.$emit('input', this.item);
        this.showSettings = false;
    }

    private stringHasValue(value: string) {
        if (!value || value === '') {
            return false;
        }
        return true;
    }

    get dataValid() {
        if (this.stringHasValue(this.item.category) &&
        this.stringHasValue(this.item.type)) {
            return true;
        }
        return false;
    }

    get isSuccess() {
        if (this.item.successValue === null) {
            return false;
        }

        switch (this.item.successToken) {
            case '=':
                return this.data.value === this.item.successValue;
            case '<':
                return this.data.value < this.item.successValue;
            case '>':
                return this.data.value > this.item.successValue;
            case '<=':
                return this.data.value <= this.item.successValue;
            case '>=':
                return this.data.value >= this.item.successValue;
        }

        return false;
    }

    get isWarning() {
        if (this.item.warningValue === null) {
            return false;
        }

        switch (this.item.warningToken) {
            case '=':
                return this.data.value === this.item.warningValue;
            case '<':
                return this.data.value < this.item.warningValue;
            case '>':
                return this.data.value > this.item.warningValue;
            case '<=':
                return this.data.value <= this.item.warningValue;
            case '>=':
                return this.data.value >= this.item.warningValue;
        }

        return false;
    }

    get isDanger() {
        if (this.item.dangerValue === null) {
            return false;
        }

        switch (this.item.dangerToken) {
            case '=':
                return this.data.value === this.item.dangerValue;
            case '<':
                return this.data.value < this.item.dangerValue;
            case '>':
                return this.data.value > this.item.dangerValue;
            case '<=':
                return this.data.value <= this.item.dangerValue;
            case '>=':
                return this.data.value >= this.item.dangerValue;
        }

        return false;
    }

    get categoryOptions() {
        return {
            items: kpiObjects.categories,
            valueExpr: 'value',
            displayExpr: 'display',
        };
    }

    get tokenOptions() {
        return {
            items: ['=', '>', '<', '>=', '<='],
        };
    }

    get typeOptions() {
        return {
            items: kpiObjects.types.filter((o) => o.category === this.item.category),
            valueExpr: 'value',
            displayExpr: 'display',
        };
    }

    get widthOptions() {
        return {
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        };
    }

    get title() {
        if (this.item.name && this.item.name !== '') {
            return this.item.name;
        }

        return 'KPI';
    }
}
